<template>
<div>
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<!-- no projects-->
<template v-if="brand_projects.length">

<ProjectCard v-for="brand_project in brand_projects" :key="brand_project.id" :project_id="brand_project.id" :show_project_link="true">
  

</ProjectCard>


</template>
<!-- projects-->
<!-- no projects-->
<template v-else>
<div class="grid">
<div class="col-12">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">Henüz tanımlanmış proje bulunmuyor</h3>
</div>
</div>
</div>
</template>
<!-- no projects-->
</template>


</div>
</template>

<script>
export default {

  name: 'BrandStatus',

  data () {
    return {
      loading:true,
      brand_projects:null,
    }
  },
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',"durum")
    this.getData()
  },
  methods:{
    async getData()
    {
        this.loading = await true
        this.brand_projects = await this.generalApiGetWithoutLoader("brand_projects/"+this.$route.params.id)
        this.loading = await false
    }
  }
}
</script>

<style lang="css" scoped>
</style>